import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import moment from 'moment';
import 'moment/dist/locale/en-au';
import 'moment/dist/locale/hi';
import 'moment/dist/locale/ko';
import 'moment/dist/locale/ur';
import 'moment/dist/locale/zh-cn';
import 'moment/dist/locale/zh-hk';
import 'moment/dist/locale/zh-tw';

dayjs.extend(relativeTime);

moment.locale([...navigator.languages, 'en-au']);
moment.updateLocale('en-au', {
    // @ts-expect-error moment should allow partial
    longDateFormat: {
        LT: 'h:mm a',
    },
});
